import { lazy, Suspense } from 'react';
import { useT } from '@/i18n/use-t';

/**
 * Lazy-loaded Monaco JSON editor for the flow-rules declarative view.
 * Monaco is ~3 MB; only admins who open the JSON tab pull the chunk.
 */
const Editor = lazy(() => import('@monaco-editor/react').then((m) => ({ default: m.default })));

export function MonacoJsonEditor({
  value,
  onChange,
  height = 480,
}: {
  value: string;
  onChange: (v: string) => void;
  height?: number;
}) {
  const t = useT('admin_ui');
  return (
    <Suspense
      fallback={
        <div
          className="flex items-center justify-center rounded-md border border-border bg-card text-sm text-muted-foreground"
          style={{ height }}
        >
          {t('terminalFlows.editor.loadingEditor', 'Loading editor…')}
        </div>
      }
    >
      <div className="overflow-hidden rounded-md border border-border">
        <Editor
          height={`${height}px`}
          defaultLanguage="json"
          value={value}
          theme="vs-dark"
          options={{
            minimap: { enabled: false },
            fontSize: 13,
            tabSize: 2,
            scrollBeyondLastLine: false,
          }}
          onChange={(v) => onChange(v ?? '')}
        />
      </div>
    </Suspense>
  );
}
